import React from "react";
import Box from "@mui/material/Box";
import PrimaryMenu from "../Menu/PrimaryMenu";
import { useSelector } from "react-redux";
const CustomNavbar = () => {
  const { isPublicHeader } = useSelector((state) => state.app);
  return (
    <>
      <nav>
        <Box display={"flex"}>
          {isPublicHeader && (
            <>
              <PrimaryMenu
                menuTitle="Employers"
                navigateTo="/employer-landingPage"
              />
              <PrimaryMenu
                menuTitle="Jobseekers"
                navigateTo="/"
              />
              <PrimaryMenu
                menuTitle="Freelancers"
                navigateTo="/freelancer-landingPage"
              />
              <PrimaryMenu
                menuTitle="HR Documents"
                menuItems={[
                  {
                    title: "HR Policy",
                    to: "/hrPolicy",
                  },
                  {
                    title: "Job Descriptions",
                    to: "/jobDescription",
                  },
                ]}
              />
            </>
          )}{" "}
          <PrimaryMenu menuTitle="Blog" navigateTo="/blogs" />
          <PrimaryMenu menuTitle="Contact us" navigateTo="/contact-us" />
        </Box>
      </nav>
    </>
  );
};

export default CustomNavbar;
